// extracted by mini-css-extract-plugin
module.exports = {"alert":"styles_alert__3ozaK","warning":"styles_warning__2iv7I","error":"styles_error__3rvsH","title":"styles_title__1kzI0","message":"styles_message__3I3hL"};